import { Data } from '@angular/router';

import { applicationRouteNames } from '../../app/application-route-names';
import { MpsRoleHelper } from '../../app/helpers/mps-role.helper';
import { MpsUser } from '../../app/models/mps-user.model';

export class MpsPermissionHelper {
  /**
   * Source unique des droits d'écran : `data.roles` de chaque route (menu et guard).
   * Une route sans `roles` reste accessible à tout utilisateur connecté.
   * L'administrateur accède à toutes les routes.
   */
  static canUserActivate(user: MpsUser, route: { data?: Data }): boolean {
    const allowedRoles: string[] = route.data?.['roles'] ?? [];

    if (allowedRoles.length === 0) {
      return true;
    }

    return this.isAdmin(user) || this.hasAnyRole(user, allowedRoles);
  }

  /**
   * Un utilisateur sans rôle métier (dont USER) n'accède à aucune partie de l'application.
   */
  static hasApplicationAccess(user: MpsUser): boolean {
    return this.hasAnyRole(user, MpsRoleHelper.BUSINESS_ROLES);
  }

  /**
   * Page d'accueil propre au rôle : le recruteur n'a accès qu'aux formulaires.
   */
  static defaultRouteFor(user: MpsUser): string {
    return this.roleCodeOf(user) === MpsRoleHelper.RECRUTEUR && !this.isAdmin(user)
      ? applicationRouteNames.nouvelleDemande
      : applicationRouteNames.historiqueContrats;
  }

  static isAdmin(user: MpsUser): boolean {
    return this.roleCodeOf(user) === MpsRoleHelper.ADMIN;
  }

  static hasAnyRole(user: MpsUser, rolesList: string[]): boolean {
    const roleCode = this.roleCodeOf(user);

    return roleCode !== undefined && rolesList.some((allowed) => allowed.toUpperCase() === roleCode);
  }

  /**
   * Lit le code du rôle sur l'objet brut : l'utilisateur du header et du store vient de l'API
   * et n'est pas forcément une instance de MpsUser (pas de méthodes isRole / isAdmin).
   */
  private static roleCodeOf(user: MpsUser): string | undefined {
    return user.role?.code?.toUpperCase();
  }
}
